import _ from "underscore";
import $$ from "squeak";
import pagesConfig from "../../global/pages.js"
import flakes from "../../scripts/flakes/index.js";

//
//                              MAKE LIST OF LOGOS

var logosList = [];

_.each(pagesConfig, function (group) {
  _.each(group.subpages, function (subpages, groupName) {
    _.each(subpages, function (moduleName) {
      if (_.isObject(moduleName)) moduleName = moduleName.name; // support squik custom case
      logosList.push({
        url: group.url + moduleName +"/",
        name: moduleName,
      });
    });
  });
});

//
//                              DISPLAY FLAKES

flakes({
  logos: logosList,
  quantity: 25,
  recursive: 1,
  firstLevelLogos: true,
});

//
//                              DISPLAY CONTENT

// BODY
var $body = $app.div({ class: "body", });

// LOGO
$body.img({
  class: "logo",
  src: "/share/logo.png",
});

// TITLE
$body.div({
  class: "title",
  text: "Squeak libraries and apps",
});

// DESCRIPTION
$body.div({
  class: "description",
  html: [
    "Apps, sites, and libraries to empower users.",
    "",
    "Free as in freedom,",
    "designed for decentralization and privacy",
    "with simple and standard technologies.",
  ].join("<br>"),
});

// BUTTONS
var $buttons = $body.div({ class: "buttons", });
_.each(pagesConfig, function (group) {
  $buttons.a({
    class: "squik-button",
    text: group.name,
    href: group.url,
  });
});

//                              ¬
//
